export default __webpack_public_path__ + "static/media/WasteKing.f81b4a52.svg";